@if(layouttemplate()=='blank'){
  <main class="mainlayout  " >

    <div class="content-block flex"    appResizewindow>
      <section class="content-main-blank"> <router-outlet /></section>
    </div>
  </main>
}@else{
 
     <router-outlet /> 

  
}
<app-toast></app-toast>
<app-alert-popup></app-alert-popup>
<app-confirmpopup></app-confirmpopup>
@if(getLoaderVisible()){
  <app-global-loader></app-global-loader>
}

